module.exports = __webpack_public_path__ + "img/18.d1659223.png";